"use client";

import React from "react";
import assets from "../assets/Assets";
import "../css/global.css";
import CartMenu from "@/components/CartMenu";

const MenuBar = () => {
  return (
    <nav className="navbar navbar-light bg-white py-3 shadow-sm border-0">
      <div className="container">
        <div className="d-flex align-items-center justify-content-between w-100">
          <a href="https://dovercompany.com" className="navbar-brand mb-0">
            <img
              src={assets.mainLogo}
              alt="Dover Doors"
              style={{ maxHeight: "70px" }}
            />
          </a>

          {/* Cart always visible (desktop + mobile) */}
          <div className="d-flex align-items-center">
            <CartMenu />
          </div>
        </div>
      </div>
    </nav>
  );
};

export default MenuBar;
